
//Header scroll logic

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  function updateHeaderScroll() {
    header.classList.toggle('scrolled', window.scrollY > 50);
  }

  window.addEventListener('scroll', updateHeaderScroll, { passive: true });
  updateHeaderScroll();
});


//Hero section slider logic

document.addEventListener("DOMContentLoaded", function () {

  const heroSection = document.querySelector(".shrike-hero");
  if (!heroSection) return;

  const slides = document.querySelectorAll(".shrike-slide");
  const dots = document.querySelectorAll(".shrike-dot");

  if (!slides.length) return;

  // Disable slider if hero section is a grid layout (desktop or mobile)
  const isGrid = window.getComputedStyle(heroSection).display === "grid";
  if (isGrid) return;

  let current = 0;
  let interval;

  function showSlide(index) {
    slides.forEach(slide => slide.classList.remove("active"));
    dots.forEach(dot => dot.classList.remove("active"));

    slides[index].classList.add("active");
    if (dots[index]) dots[index].classList.add("active");

    current = index;
  }

  function startSlider() {
    interval = setInterval(function () {
      let next = (current + 1) % slides.length;
      showSlide(next);
    }, 5000);
  }

  // Initial
  showSlide(0);
  startSlider();

  // Dot click
  dots.forEach(dot => {
    dot.addEventListener("click", function () {
      clearInterval(interval);
      showSlide(parseInt(this.dataset.index));
      startSlider();
    });
  });

});


document.addEventListener('DOMContentLoaded', () => {
  function updateWornImage(input) {
    const wornDiv = document.getElementById('variant-worn-image');
    if (!wornDiv) return;
    const img = wornDiv.querySelector('img');
    const wornSrc = input?.dataset?.wornImage;
    if (wornSrc) {
      img.src = wornSrc;
      wornDiv.style.display = 'block';
    } else {
      wornDiv.style.display = 'none';
    }
  }

  // Handle swatch (radio) inputs
  document.addEventListener('change', (e) => {
    const input = e.target.closest('input[data-worn-image], input[name*="Color"]');
    if (input) updateWornImage(input);
  });

  // Also handle swatch-input custom elements if Dawn uses them
  document.addEventListener('click', (e) => {
    const label = e.target.closest('label[for]');
    if (!label) return;
    const input = document.getElementById(label.htmlFor);
    if (input?.dataset?.wornImage !== undefined) updateWornImage(input);
  });

  // Init on page load with the currently selected color
  const checked = document.querySelector('input[data-worn-image]:checked');
  if (checked) updateWornImage(checked);
});

// Header Hover to Open details menus on desktop
document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(min-width: 990px)').matches) {
    const headerDetails = document.querySelectorAll('header-menu details');
    headerDetails.forEach(details => {
      let timeout;
      
      const openMenu = () => {
        clearTimeout(timeout);
        details.setAttribute('open', '');
        details.classList.add('menu-hovering');
      };
      
      const closeMenu = () => {
        timeout = setTimeout(() => {
          details.removeAttribute('open');
          details.classList.remove('menu-hovering');
        }, 150);
      };
      
      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', closeMenu);
      
      // Also handle nested summaries to prevent clicks from closing
      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (e) => {
          if (details.classList.contains('menu-hovering')) {
            e.preventDefault(); // Prevent toggle since hover handles open/close
          }
        });
      }
    });
  }
});

if (!window.giftWrapInitialized) {
  window.giftWrapInitialized = true;

  // Gift Wrap AJAX Checkbox Logic
  document.addEventListener('change', (event) => {
    const checkbox = event.target;
    if (checkbox && (checkbox.id === 'Cart-GiftWrap' || checkbox.id === 'CartDrawer-GiftWrap')) {
      const variantId = checkbox.dataset.variantId || '54347226317013';
      const isChecked = checkbox.checked;
      
      // Disable both checkboxes while updating to avoid duplicate clicks / race conditions
      const allCheckboxes = document.querySelectorAll('#Cart-GiftWrap, #CartDrawer-GiftWrap');
      allCheckboxes.forEach(cb => cb.disabled = true);
      
      // Determine which sections to render based on the current context (cart page vs cart drawer)
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      const cartItems = document.querySelector('cart-items');
      
      let sectionsToRender = [];
      if (cartDrawerItems) {
        sectionsToRender = cartDrawerItems.getSectionsToRender();
      } else if (cartItems) {
        sectionsToRender = cartItems.getSectionsToRender();
      } else {
        sectionsToRender = [
          { id: 'cart-drawer', section: 'cart-drawer', selector: '.drawer__inner' },
          { id: 'main-cart-footer', section: 'main-cart-footer', selector: '.js-contents' },
          { id: 'main-cart-items', section: 'main-cart-items', selector: '.js-contents' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
        ];
      }
      
      const sectionIds = sectionsToRender.map(s => s.section || s.id);
      
      let url, body;
      if (isChecked) {
        // Add Gift Wrap
        url = `/cart/add.js?sections=${sectionIds.join(',')}`;
        body = JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        });
      } else {
        // Remove Gift Wrap (set quantity to 0)
        url = '/cart/change.js';
        body = JSON.stringify({
          id: String(variantId),
          quantity: 0,
          sections: sectionIds,
          sections_url: window.location.pathname
        });
      }
      
      // Disable cart actions visually (similar to Dawn's default loading indicator)
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      if (mainCartItems) {
        mainCartItems.classList.add('cart__items--disabled');
      }
      
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: body
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to update cart');
        }
        return response.json();
      })
      .then(parsedState => {
        // Re-enable checkboxes
        allCheckboxes.forEach(cb => cb.disabled = false);
        if (mainCartItems) {
          mainCartItems.classList.remove('cart__items--disabled');
        }
        
        // Update DOM for each rendered section
        sectionsToRender.forEach((section) => {
          const sectionId = section.section || section.id;
          const selector = section.selector;
          const targetElement = document.getElementById(section.id)?.querySelector(selector) || document.getElementById(section.id);
          
          if (targetElement && parsedState.sections && parsedState.sections[sectionId]) {
            const newHtml = new DOMParser()
              .parseFromString(parsedState.sections[sectionId], 'text/html')
              .querySelector(selector || `#${section.id}`)?.innerHTML;
              
            if (newHtml !== undefined) {
              targetElement.innerHTML = newHtml;
            } else {
              const fullNewElement = new DOMParser()
                .parseFromString(parsedState.sections[sectionId], 'text/html')
                .getElementById(section.id);
              if (fullNewElement) {
                document.getElementById(section.id).replaceWith(fullNewElement);
              }
            }
          }
        });
        
        // Publish event for subscription updates (e.g. cart badge count)
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
        }
      })
      .catch(error => {
        console.error('Error updating gift wrap status:', error);
        allCheckboxes.forEach(cb => cb.disabled = false);
        if (mainCartItems) {
          mainCartItems.classList.remove('cart__items--disabled');
        }
        // Revert checked state
        checkbox.checked = !isChecked;
      });
    }
  });
}
